import $9zQyk$intldndarAEmjs from "../intl/dnd/ar-AE.mjs";
import $9zQyk$intldndbgBGmjs from "../intl/dnd/bg-BG.mjs";
import $9zQyk$intldndcsCZmjs from "../intl/dnd/cs-CZ.mjs";
import $9zQyk$intldnddaDKmjs from "../intl/dnd/da-DK.mjs";
import $9zQyk$intldnddeDEmjs from "../intl/dnd/de-DE.mjs";
import $9zQyk$intldndelGRmjs from "../intl/dnd/el-GR.mjs";
import $9zQyk$intldndenUSmjs from "../intl/dnd/en-US.mjs";
import $9zQyk$intldndesESmjs from "../intl/dnd/es-ES.mjs";
import $9zQyk$intldndetEEmjs from "../intl/dnd/et-EE.mjs";
import $9zQyk$intldndfiFImjs from "../intl/dnd/fi-FI.mjs";
import $9zQyk$intldndfrFRmjs from "../intl/dnd/fr-FR.mjs";
import $9zQyk$intldndheILmjs from "../intl/dnd/he-IL.mjs";
import $9zQyk$intldndhrHRmjs from "../intl/dnd/hr-HR.mjs";
import $9zQyk$intldndhuHUmjs from "../intl/dnd/hu-HU.mjs";
import $9zQyk$intldnditITmjs from "../intl/dnd/it-IT.mjs";
import $9zQyk$intldndjaJPmjs from "../intl/dnd/ja-JP.mjs";
import $9zQyk$intldndkoKRmjs from "../intl/dnd/ko-KR.mjs";
import $9zQyk$intldndltLTmjs from "../intl/dnd/lt-LT.mjs";
import $9zQyk$intldndlvLVmjs from "../intl/dnd/lv-LV.mjs";
import $9zQyk$intldndnbNOmjs from "../intl/dnd/nb-NO.mjs";
import $9zQyk$intldndnlNLmjs from "../intl/dnd/nl-NL.mjs";
import $9zQyk$intldndplPLmjs from "../intl/dnd/pl-PL.mjs";
import $9zQyk$intldndptBRmjs from "../intl/dnd/pt-BR.mjs";
import $9zQyk$intldndptPTmjs from "../intl/dnd/pt-PT.mjs";
import $9zQyk$intldndroROmjs from "../intl/dnd/ro-RO.mjs";
import $9zQyk$intldndruRUmjs from "../intl/dnd/ru-RU.mjs";
import $9zQyk$intldndskSKmjs from "../intl/dnd/sk-SK.mjs";
import $9zQyk$intldndslSImjs from "../intl/dnd/sl-SI.mjs";
import $9zQyk$intldndsrSPmjs from "../intl/dnd/sr-SP.mjs";
import $9zQyk$intldndsvSEmjs from "../intl/dnd/sv-SE.mjs";
import $9zQyk$intldndtrTRmjs from "../intl/dnd/tr-TR.mjs";
import $9zQyk$intldndukUAmjs from "../intl/dnd/uk-UA.mjs";
import $9zQyk$intldndzhCNmjs from "../intl/dnd/zh-CN.mjs";
import $9zQyk$intldndzhTWmjs from "../intl/dnd/zh-TW.mjs";

var $eeec32401692de43$exports = {};


































$eeec32401692de43$exports = {
    "ar-AE": $9zQyk$intldndarAEmjs,
    "bg-BG": $9zQyk$intldndbgBGmjs,
    "cs-CZ": $9zQyk$intldndcsCZmjs,
    "da-DK": $9zQyk$intldnddaDKmjs,
    "de-DE": $9zQyk$intldnddeDEmjs,
    "el-GR": $9zQyk$intldndelGRmjs,
    "en-US": $9zQyk$intldndenUSmjs,
    "es-ES": $9zQyk$intldndesESmjs,
    "et-EE": $9zQyk$intldndetEEmjs,
    "fi-FI": $9zQyk$intldndfiFImjs,
    "fr-FR": $9zQyk$intldndfrFRmjs,
    "he-IL": $9zQyk$intldndheILmjs,
    "hr-HR": $9zQyk$intldndhrHRmjs,
    "hu-HU": $9zQyk$intldndhuHUmjs,
    "it-IT": $9zQyk$intldnditITmjs,
    "ja-JP": $9zQyk$intldndjaJPmjs,
    "ko-KR": $9zQyk$intldndkoKRmjs,
    "lt-LT": $9zQyk$intldndltLTmjs,
    "lv-LV": $9zQyk$intldndlvLVmjs,
    "nb-NO": $9zQyk$intldndnbNOmjs,
    "nl-NL": $9zQyk$intldndnlNLmjs,
    "pl-PL": $9zQyk$intldndplPLmjs,
    "pt-BR": $9zQyk$intldndptBRmjs,
    "pt-PT": $9zQyk$intldndptPTmjs,
    "ro-RO": $9zQyk$intldndroROmjs,
    "ru-RU": $9zQyk$intldndruRUmjs,
    "sk-SK": $9zQyk$intldndskSKmjs,
    "sl-SI": $9zQyk$intldndslSImjs,
    "sr-SP": $9zQyk$intldndsrSPmjs,
    "sv-SE": $9zQyk$intldndsvSEmjs,
    "tr-TR": $9zQyk$intldndtrTRmjs,
    "uk-UA": $9zQyk$intldndukUAmjs,
    "zh-CN": $9zQyk$intldndzhCNmjs,
    "zh-TW": $9zQyk$intldndzhTWmjs
};


export {$eeec32401692de43$exports as default};
//# sourceMappingURL=intlStrings.mjs.map
